import React from 'react';
import '../styles/SubcategoriaCard.css'; // Asegúrate que los estilos siguen siendo adecuados

// Añadimos onCardClick como prop
function SubcategoriaCard({ nombre, descripcion, imagenUrl, enlace, onCardClick, data }) {
  // URL de imagen por defecto
  const defaultImageUrl = 'https://via.placeholder.com/300x200?text=Recomendacion';

  // Datos completos a pasar al hacer clic
  const cardData = { nombre, descripcion, imagenUrl, enlace, ...data }; // Incluir cualquier dato extra

  const handleClick = () => {
    if (onCardClick) {
      onCardClick(cardData); // Pasar todos los datos al padre
    }
  };

  return (
    // Quitamos la etiqueta <a> y añadimos onClick al div principal
    <div className="subcategoria-card" onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div className="subcategoria-card-image-container">
        <img 
          src={imagenUrl || defaultImageUrl} 
          alt={`Imagen de ${nombre}`}
          onError={(e) => { e.target.onerror = null; e.target.src=defaultImageUrl }}
        />
      </div>
      <div className="subcategoria-card-content">
        {/* Mostramos solo el nombre en la tarjeta */}
        <h3>{nombre}</h3>
        {/* La descripción ya no se muestra aquí */}
      </div>
    </div>
  );
}

// Actualizar PropTypes si es necesario, onCardClick es ahora una función

export default SubcategoriaCard; 